import React, { useCallback, useEffect, useRef } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { FiLock, FiMail, FiUser } from 'react-icons/fi';
import * as Yup from 'yup';

import { useDispatch, useSelector } from 'react-redux';
import getValidationErrors from '../../utils/getValidationErrors';

import { customerResetPassword } from '../../store/modules/auth/actions';

import Button from '../../components/Button';
import Input from '../../components/Input';

import { routesEndpoints } from '../../routes/endpoint';
import { setIsCategory } from '../../store/modules/parameter/actions';
import { AnimationContainer, ColInput, Container, Title } from './styles';

import { useHistory } from 'react-router-dom';
import { StoreState } from '../../store/createStore';

interface ResetPassFormData {
  token: string;
  email: string;
  password: string;
  password_confirmation: string;
}

const ResetPassword: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { forgotPasswordOk } = useSelector((state: StoreState) => state.auth);

  // pega o TOKEN da  url
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');

  // redirecionar para pagina Home quando não tiver token na URL
  useEffect(() => {
    if (token === null) {
      history.push(routesEndpoints.HOME);
    }
  }, [history, token]);

  const formRef = useRef<FormHandles>(null);

  const { loadingResetPassRequest, isSignedIn } = useSelector(
    (state: StoreState) => state.auth,
  );

  useEffect(() => {
    if (isSignedIn) {
      dispatch(setIsCategory(false));
    }
  }, [isSignedIn, dispatch]);

  const handleSubmit = useCallback(
    async (data: ResetPassFormData) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          token: Yup.string(),
          email: Yup.string()
            .required('E-mail obrigatório')
            .email('Digite um e-mail válido'),
          password: Yup.string()
            .required('Senha obrigatória')
            .min(6, 'No mínimo 6 digitos'),
          password_confirmation: Yup.string()
            .required('Senha obrigatória')
            .min(6, 'No mínimo 6 digitos')
            .oneOf([Yup.ref('password')], 'As senhas devem ser iguais'),
        });
        await schema.validate(data, {
          abortEarly: false,
        });
        //manda dados para a API
        dispatch(
          customerResetPassword({
            token: token,
            email: data.email,
            password: data.password,
            password_confirmation: data.password_confirmation,
          }),
        );
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
        }
      }
    },
    [dispatch, token],
  );

  useEffect(() => {
    if (forgotPasswordOk) {
      history.push('/');
    }
  }, [forgotPasswordOk, history]);
  
  return (
    <Container>
      <AnimationContainer>
        <Form ref={formRef} onSubmit={handleSubmit} autoComplete="off">
          <Title>
            <span>Redefinir Senha</span>
          </Title>
          <ColInput>
            <div style={{ marginBottom: '30px' }} />
          </ColInput>
          {process.env.REACT_APP_SELLER_MODE === '1' ? (
            <ColInput>
              <Input
                icon={FiUser}
                name="email"
                textLabel="Id vendedor"
                type="number"
                formRef={formRef}
                autoComplete="off"
              />
            </ColInput>
          ) : (
            <ColInput>
              <Input 
                icon={FiMail} 
                name="email" 
                textLabel="E-mail *" 
                formRef={formRef} 
                autoComplete="off"
              />
            </ColInput>
          )}
          <ColInput>
            <Input
              icon={FiLock}
              type="password"
              name="password"
              textLabel="Nova Senha *"
              formRef={formRef}
              autoComplete="new-password"
            />
          </ColInput>
          <ColInput>
            <Input
              icon={FiLock}
              type="password"
              name="password_confirmation"
              textLabel="Confirmar Nova Senha *"
              formRef={formRef}
              autoComplete="new-password"
            />
          </ColInput>
          <ColInput>
            <div style={{ marginBottom: '15px' }} />
          </ColInput>
          <ColInput>
            <Button
              button={{ type: loadingResetPassRequest ? 'button' : 'submit' }}
              atributes={{
                buttonType: 'primary',
                textColor: '#fff',
                textSize: '30px',
                borderColor: '#dddddd',
              }}
            >
              {loadingResetPassRequest ? 'Aguarde...' : 'REDEFINIR'}
            </Button>
          </ColInput>
        </Form>
      </AnimationContainer>
    </Container>
  );
};

export default ResetPassword;
